import styles from "./styles.module.scss";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectCreative } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import "swiper/css/effect-creative";

import Slyde from "./Carrousel/Slide";
import { useEffect } from "react";
import { useState } from "react";

function Home() {
  const team = [
    {
      description: "Responsable de resources humaines qui se charge de la comptabilité interne.",
      nom: "Yasmine",
      profession: "Foundatrice, Responsable RH",
      image: "/images/Yasmine.jfif"
    },
    {
      description: "Ingénieur en informatique treize ans d'expérience en tant que chef projet.",
      nom: "Hichem",
      profession: "Formateur en gestion de projet",
      image: "/images/hichem.jpg"
    },
    {
      description: "Ingénieur en informatique et reponsable du développement des outils informatique et logiciels en interne.",
      nom: "Yassine",
      profession: "Ingénieur en informatique",
      image: "/images/yassine1.jpg"
    },
    
   /*  {
      description: "text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text",
      nom: "Hichem",
      profession: "Founder",
      image: "/images/hichem.jpg"
    },
    {
      description: "text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text",
      nom: "Hichem",
      profession: "Founder",
      image: "/images/hichem.jpg"
    },
    {
      description: "text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text",
      nom: "Hichem",
      profession: "Founder",
      image: "/images/hichem.jpg"
    },*/
  ];
 
  const [slides, setSlides] = useState()
  useEffect(() => {
    console.log(slides);
    window.screen.availWidth < 500 ? (setSlides(1)):(setSlides(3));
    console.log(slides);
  },[])
  return (
    <>

      <section className={styles.container}>
        <div className={styles.box}>
          <text>NOTRE EQUIPE</text>

          <div className={styles.slider}>
            <Swiper
              modules={[Navigation, Pagination, Scrollbar, Autoplay, EffectCreative]}
              spaceBetween={0}
              slidesPerView={slides}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              creativeEffect={{
                prev: {
                  shadow: true,
                  translate: ["-125%", 0, -800],
                  rotate: [0, 0, -90],
                },
                next: {
                  shadow: true,
                  translate: ["125%", 0, -800],
                  rotate: [0, 0, 90],
                },
              }}
            >
              {team?.map((member, i) => (
                <SwiperSlide><Slyde team={member} /></SwiperSlide>
              ))}

            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;